module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/stores/3_35b5ec6611b629feadf916b29d831f89.jpg";